import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { useTranslation } from "react-i18next";
import { BranchCreateFormFields } from "./_components/create-form-fields";

export function CreateView() {
  const { t } = useTranslation(["masterdata", "common"]);

  return (
    <CenteredLayout
      variant={CenteredLayoutVariant.Form}
      title={t("masterdata:CreateBranch")}
      subTitle={t("common:CompleteRequiredInformationDescription")}
    >
      <BranchCreateFormFields />
    </CenteredLayout>
  );
}
